import { render, staticRenderFns } from "./subdetail.vue?vue&type=template&id=39651e13"
import script from "./subdetail.vue?vue&type=script&lang=ts"
export * from "./subdetail.vue?vue&type=script&lang=ts"
import style0 from "./subdetail.vue?vue&type=style&index=0&id=39651e13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports